import { render } from "./TrackAddOtherIncome.vue?vue&type=template&id=55dec160&scoped=true"
import script from "./TrackAddOtherIncome.vue?vue&type=script&lang=js"
export * from "./TrackAddOtherIncome.vue?vue&type=script&lang=js"

import "./TrackAddOtherIncome.vue?vue&type=style&index=0&id=55dec160&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dec160"]])

export default __exports__